
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-primary",attrs:{"d":"M29.99 59.979c16.562 0 29.989-13.427 29.989-29.99C59.979 13.427 46.552 0 29.989 0 13.427 0 0 13.427 0 29.99c0 16.562 13.427 29.989 29.99 29.989z","fill":"#8CD1D0"}}),_c('path',{attrs:{"d":"M38.879 21.99h-.699v-1.546a4.033 4.033 0 00-4.02-4.02h-8.424a4.033 4.033 0 00-4.021 4.02v1.545h-.635a4.033 4.033 0 00-4.021 4.021v6.477a4.033 4.033 0 004.02 4.02h.636v5.08c0 1.1.91 2.01 2.01 2.01H36.17c1.1 0 2.01-.91 2.01-2.01v-5.08h.699a4.033 4.033 0 004.02-4.02V26.01a4.02 4.02 0 00-4.02-4.02zm-15.62-1.546a2.502 2.502 0 012.498-2.497h8.423a2.502 2.502 0 012.498 2.497v1.545H23.28v-1.545h-.021zm13.398 21.122a.492.492 0 01-.487.487H23.725a.492.492 0 01-.487-.487v-8.381h13.397v8.381h.022zm4.72-9.1a2.502 2.502 0 01-2.498 2.497h-.699v-1.778h.995a.759.759 0 00.762-.762.759.759 0 00-.762-.762h-18.54a.759.759 0 00-.762.762.76.76 0 00.762.762h1.122v1.778h-.635a2.502 2.502 0 01-2.497-2.498V25.99a2.502 2.502 0 012.497-2.497H38.9a2.502 2.502 0 012.497 2.497v6.476h-.02z","fill":"#fff"}}),_c('path',{attrs:{"d":"M25.1 36.931h9.672a.759.759 0 00.762-.762.759.759 0 00-.762-.762H25.1a.759.759 0 00-.762.762c0 .423.338.762.762.762zm9.736 1.587h-9.672a.759.759 0 00-.762.762.76.76 0 00.762.762h9.672a.759.759 0 00.762-.762c-.021-.423-.36-.762-.762-.762zm4.022-13.545h-1.545a.759.759 0 00-.762.762c0 .424.338.762.762.762h1.545a.759.759 0 00.762-.762.759.759 0 00-.762-.762z","fill":"#fff"}})])
          )
        }
      }
    